import Axios from 'axios'
import config from '@/config/config.js'

// const baseUrl = 'http://192.168.119.122:8081/api/codetable'
// const baseUrl = '/b3/training-task-list/api/training/'
const baseUrl = config.apiDomain.ALI + '/ext/training/tasklist/api/'
const activeWorkItemsUrl = baseUrl + 'personalActiveWorkItems'
const historyWorkItemsUrl = baseUrl + 'personalHistoryWorkItems'
const appraiserReasonsUrl = baseUrl + 'appraiserReasons'
const nextSCUrl = baseUrl + 'defaultNextStaff'
// const personalActiveWorkItemsUrl = baseUrl + '/personalActiveWorkItems/'
const activeClassSummariesUrl = activeWorkItemsUrl + '/classSummaries'
const activeProposalClassesUrl = activeWorkItemsUrl + '/proposalClasses/'
const historyProposalClassesUrl = historyWorkItemsUrl + '/proposalClasses/'
const completeTSUrl = baseUrl + 'completeTrainingStep'
const attentionActiveWorkItemsUrl = baseUrl + 'followActiveWorkItems/' // /{euid}
const trainingInfoByStaffCodeUrl = (config.isUAT ? 'https://api-uat.g2e.informac.gov.mo/' : 'https://api.g2e.gov.mo/') + 'ext/training/api/zsoft/trainingInfoByStaffCode?staffCode='
const trainingInfoByStaffCode3Url = (config.isUAT ? 'https://api-uat.g2e.informac.gov.mo/' : 'https://api.g2e.gov.mo/') + 'ext/training/api/zsoft/myTrainingInfo'
const trainingInfoByStaffCode2Url = (config.isUAT ? 'https://api-uat.g2e.informac.gov.mo/' : 'https://api.g2e.gov.mo/') + 'ext/training/api/tc/ipf/getPersonalInternalProposeForm'

Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// Axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*'
// Axios.defaults.headers.get['Access-Control-Allow-Headers'] = 'Authorization,Origin, X-Requested-With, Content-Type, Accept'
// Axios.defaults.headers.get['Access-Control-Allow-Methods'] = 'GET,POST'
Axios.defaults.headers.timeout = 8000

export default {
  getAppraiserReasons (cb) {
    Axios.get(appraiserReasonsUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getDefaultNextStaff (cb) {
    Axios.get(nextSCUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getActiveItems (cb) {
    Axios.get(activeWorkItemsUrl).then(
      response => {
        if (response.status === 200) {
          cb(response.data)
        } else {
          cb()
        }
      },
      error => {
        console.error(error)
      }
    )
  },

  getClassSummariesActiveItems (cb) {
    Axios.get(activeClassSummariesUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getActiveItemsByProposalClassId (cb, proposalClassId) {
    Axios.get(activeProposalClassesUrl + proposalClassId).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getAttentionActiveItemsByEuid (cb, euid) {
    Axios.get(attentionActiveWorkItemsUrl + euid).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getHistoryItems (cb) {
    Axios.get(historyWorkItemsUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getHistoryItemsByProposalClassId (cb, proposalClassId) {
    Axios.get(historyProposalClassesUrl + proposalClassId).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  completeTrainingStep (cb, itemList) {
    Axios.post(completeTSUrl, itemList).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        // console.error(error)
        cb(error.response)
      }
    )
  },

  getTrainingInfoByStaffCode (cb, staffCode) {
    console.log('getTrainingInfoByStaffCode : ' + trainingInfoByStaffCodeUrl + staffCode)
    Axios.get(trainingInfoByStaffCodeUrl + staffCode).then(
      response => {
        console.log(response.status)
        if (response.status === 200) {
          console.log(response.data)
          cb(response)
        } else {
          cb()
        }
      },
      error => {
        console.error(error)
      }
    )
  },

  getTrainingInfo2 (cb) {
    console.log('getTrainingInfoByStaffCode : ' + trainingInfoByStaffCode3Url)
    Axios.get(trainingInfoByStaffCode3Url).then(
      response => {
        console.log(response.status)
        if (response.status === 200) {
          console.log(response.data)
          cb(response)
        } else {
          cb()
        }
      },
      error => {
        console.error(error)
      }
    )
  }

}
